module.exports = __webpack_public_path__ + "img/Icon_Discusion_Hover.1d165f9b.svg";